import { Grade, Subject, Board, CognitiveDemand, GuidanceLevel, ContextLevel, AssessmentType, QuestionType, DensityLevel } from './types';

export const GRADES: Grade[] = [
  Grade.GRADE_1, Grade.GRADE_2, Grade.GRADE_3, Grade.GRADE_4, Grade.GRADE_5, Grade.GRADE_6,
  Grade.GRADE_7, Grade.GRADE_8, Grade.GRADE_9, Grade.GRADE_10, Grade.GRADE_11, Grade.GRADE_12,
];

export const ATYPICAL_GRADES: Grade[] = [
  Grade.GRADE_6, Grade.GRADE_7, Grade.GRADE_8, Grade.GRADE_9, Grade.GRADE_10, Grade.GRADE_11, Grade.GRADE_12,
];

export const SUBJECTS: Subject[] = [
  Subject.ENGLISH, Subject.MATHS, Subject.SCIENCE, Subject.SOCIAL_STUDIES, Subject.OTHER, Subject.ALL,
];

export const BOARDS: Board[] = [
    Board.CBSE, Board.ICSE, Board.STATE_BOARD, Board.CAMBRIDGE,
];

export const ASSESSMENT_TYPES: AssessmentType[] = [
  AssessmentType.MID_TERM,
  AssessmentType.FINAL_EXAM,
  AssessmentType.PA_1,
  AssessmentType.PA_2,
  AssessmentType.UNIT_TEST,
];

// FIX: Add missing QUESTION_TYPES constant.
export const QUESTION_TYPES: QuestionType[] = [
  QuestionType.MCQ,
  QuestionType.SUBJECTIVE,
  QuestionType.MIXED,
];

export const DENSITY_LEVELS: DensityLevel[] = [
  DensityLevel.LOW,
  DensityLevel.MEDIUM,
  DensityLevel.HIGH,
];

export const COGNITIVE_DEMANDS: CognitiveDemand[] = [
  CognitiveDemand.RECALL_HEAVY,
  CognitiveDemand.BALANCED,
  CognitiveDemand.REASONING_HEAVY,
];

export const GUIDANCE_LEVELS: GuidanceLevel[] = [
  GuidanceLevel.HIGH,
  GuidanceLevel.MEDIUM,
  GuidanceLevel.LOW,
];

export const CONTEXT_LEVELS: ContextLevel[] = [
  ContextLevel.TEXTBOOK_ONLY,
  ContextLevel.MIXED,
];

export const SHAPE_SHIFTER_TOGGLES = [
  { label: 'Large Class', key: 'largeClass' },
  { label: 'Limited Tech', key: 'limitedTech' },
  { label: 'Resource Light', key: 'resourceLight' },
];